export const NOTIFICATION_TYPE = {
    SUCCESS: 'ALERT_SUCCESS',
    INFO: 'ALERT_INFO',
    ERROR: 'ALERT_ERROR',
    WARNING: 'ALERT_WARNING',
    CLEAR: 'ALERT_CLEAR'
};